import axios from 'axios';

const API_VERSION = 2;

const apiClient = axios.create({
  //baseURL: '/mobile-pass-v4/',
  baseURL: '/pass/',
  timeout: 30000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
});

const urlParams = new URLSearchParams(window.location.search);

apiClient.interceptors.request.use(config => {
  config.headers['BW-token'] = window.token
  config.headers['BW-Api-Version'] = API_VERSION
  config.params = { ...config.params, t: window.token }

  if (urlParams.get('dealId')) {
    config.params.dealId = urlParams.get('dealId')
  }

  return config
})

export default apiClient;
